import { Position, PositionCode } from "../../../../../constants";
import { DateHelper, StringHelper } from "../../../../../helper";
import {
  form10,
  form11,
  form13,
  form132,
  form19,
  form20,
  form21,
  form22,
  form23,
  form24,
  form25,
  form26,
  form27,
  form28,
  form29,
  form30,
  form31,
  form32,
  form33,
  form34,
  form35,
  form36,
  form37,
  form38,
  form39,
  form40,
  form41,
  form42,
  form43,
  form44,
  form45,
  form8,
  form9,
} from "../constants/word-forms";
import { form46 } from "../constants/word-forms/form-46";
import { form47 } from "../constants/word-forms/form-47";
import { form48 } from "../constants/word-forms/form-48";
import { AFLType } from "../models";
import { isInGroup } from "../pages/absence-letter/absence-letter-create";

const posDirector = [PositionCode.GD];
const posGroups1 = [PositionCode.PGD, PositionCode.PTGD, PositionCode.KTT];
const posGroups2 = [PositionCode.TP, PositionCode.TTT];
const posGroups3 = [PositionCode.PP, PositionCode.PTT, PositionCode.DT, PositionCode.DP];
// const posGroups4 = [PositionCode.DT];
// const posGroup45 = [PositionCode.DT, PositionCode.DP, PositionCode.ĐT, PositionCode.ĐP];
// const posGroups5 = [
//   PositionCode.PGD,
//   PositionCode.PTGD,
//   PositionCode.KTT,
//   PositionCode.TP,
//   PositionCode.TTT,
//   PositionCode.PP,
//   PositionCode.PTT,
//   PositionCode.DT,
// ];

export const getUnitCode = ({ eBranch, eDepartment, eUnit }: any) => {
  const [branch] = StringHelper.verticalBarSplit(eBranch);
  const isKCQ = branch === "KCQ";

  if (isKCQ) return StringHelper.verticalBarSplit(eDepartment)[0];
  return StringHelper.verticalBarSplit(eUnit)[0];
};

export const getWordValue = (record: any): any => {
  const eApprovalProcess = record?.eApprovalProcess;
  // const dayOffNum = DateHelper.countWeekdays(record?.eVacationPeriod);
  const [aflType] = StringHelper.verticalBarSplit<[AFLType]>(record.eAFLType);
  const [position] = StringHelper.verticalBarSplit<[Position]>(record.eTitle);
  const [branch] = StringHelper.verticalBarSplit(record.eBranch);
  // const isDN = ["DAD", "VDAD", "3"].includes(departmentCode);
  const isNB = ["NBA", "VNBA", "2"].includes(branch);
  const isDAD = ["DAD", "VDAD", "3"].includes(branch);
  // const isKCQ = branch === "KCQ";
  const isTSN = ["TSN", "VTSN", "1"].includes(branch);

  const dayOffNum =
    record?.eVacationPeriods && !record?.eVacationPeriods.some((i: any) => Boolean(!i))
      ? DateHelper.duration(record?.eVacationPeriods!).days()
      : 0;

  const department = StringHelper.verticalBarSplit(record?.eDepartment)[1];

  if (aflType === AFLType.AFLNoSalary) {
    if (isDAD) return form43(record);
    else if (isTSN) return form46(record);
    return form27(record);
  }
  if (aflType === AFLType.AFLSuspendContract) {
    if (isDAD) return form44(record);
    else if (isTSN) return form47(record);
    return {
      departmentCode: "ALL",
      aflType: AFLType.AFLSuspendContract,
      layout: [
        { type: "header", value: { form: 1, department } },
        {
          type: "title",
          value: {
            sub: [],
          },
        },
        {
          type: "salutation",
          value: [
            "Tổng Giám đốc",
            `Trưởng phòng ${StringHelper.verticalBarSplit(record?.eUnit)[1]};`,
            "Trưởng phòng Tổ chức và Nhân lực.",
          ],
        },
        {
          type: "content",
          value: [
            { type: "eRequestName", value: record?.eRequestName },
            { type: "eEmployeeId", value: record?.eEmployeeId },
            {
              type: "ePosition",
              value: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
            },
            {
              type: "",
              value: `Đơn vị: ${StringHelper.verticalBarSplit<string[]>(record?.eDepartment)[1]}`,
            },
            { type: "eAddress", value: record?.eAddress },
            { type: "eBusinessTime", value: record?.eBusinessTime || "" },
            { type: "eReason", value: record?.eReason },
            {
              type: "",
              value: `Nay tôi kính mong ông Tổng Giám đốc cho phép tôi được nghỉ không lương tại ${
                record?.eAddress
              }. kể từ ${DateHelper.formatDateToString(record?.eVacationPeriod[0])} đến ${DateHelper.formatDateToString(
                record?.eVacationPeriod[1],
              )}.`,
            },
            {
              type: "",
              value: `Tôi xin cam đoan trả lại ${
                record?.eAssetReturnNum || "   "
              } các trang thiết bị, vật tư, công cụ dụng cụ (nếu được cấp), thẻ công tác và thực hiện các thủ tục thanh toán nghỉ không lương theo đúng quy định của Công ty và của Pháp luật hiện hành.`,
            },
            { type: "", value: "Xin trân trọng cảm ơn." },
          ],
        },
        {
          type: "footer",
          value: [
            {
              type: "signature1",
              value: ["TRƯỞNG PHÒNG TCNL", eApprovalProcess[3][0].name],
            },
            {
              type: "signature1",
              value: ["THỦ TRƯỞNG ĐƠN VỊ", eApprovalProcess[1][0].name],
            },
            {
              type: "signature1",
              value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
            },
          ],
        },
        {
          type: "footer",
          value: [
            {
              type: "recipients",
              value: ["- Như trên;", "- Lưu TCNL."],
            },
            {
              type: "signature1",
              value: ["PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC", eApprovalProcess[4][0].name],
            },
          ],
          textBreak: 1,
        },
      ],
    };
  }
  if (aflType === AFLType.TerminationContractApplication) {
    if (isDAD) return form45(record);
    else if (isTSN) return form48(record);
    return form28(record);
  }
  if (aflType === AFLType.AccidentNotification) {
    if (isNB) return form11(record);
    return form26(record);
  }
  if (aflType === AFLType.AccidentLeaveApplication) {
    if (isNB) return form10(record);
    return form25(record);
  }
  if (aflType === AFLType.SickLeaveApplication) {
    if (isNB) return form9(record);
    if (isDAD) return form42(record);
    return form24(record);
  }
  if (aflType === AFLType.MaternityLeaveApplication) {
    if (isNB) return form8(record);
    if (isDAD) return form41(record);
    return form23(record);
  }
  if (aflType === AFLType.ApplicationForLeave) {
    const isPositionsGroup1 = isInGroup(position, posGroups1);
    const isPositionsGroup2 = isInGroup(position, posGroups2);
    const isPositionsGroup3 = isInGroup(position, posGroups3);
    const isPositionsGroup45 = isInGroup(position, posGroups3);
    const isDirectorPosition = isInGroup(position, posDirector);
    if (isTSN) {
      if (isInGroup(position, [PositionCode.DT, PositionCode.PTT])) {
        return form13(record);
      }
      return form132(record);
    } else if (isNB) {
      if (isDirectorPosition) return form29(record);
      if ((isPositionsGroup1 && dayOffNum < 3) || (isPositionsGroup2 && dayOffNum < 5)) return form30(record);
      if ((isPositionsGroup1 && dayOffNum >= 3) || (isPositionsGroup2 && dayOffNum >= 5)) return form31(record);
      if (isPositionsGroup3 && dayOffNum >= 3) return form32(record);
      if (isPositionsGroup3 && dayOffNum < 3) return form33(record);
      return form34(record);
    } else if (isDAD) {
      if (isDirectorPosition) return form35(record);
      if ((isPositionsGroup1 && dayOffNum < 3) || (isPositionsGroup2 && dayOffNum < 5)) return form36(record);
      if ((isPositionsGroup1 && dayOffNum >= 3) || (isPositionsGroup2 && dayOffNum >= 5)) return form37(record);
      if (isPositionsGroup45) return form38(record);
      if (record.isOverseas) return form40(record);
      return form39(record);
    } else {
      if (isPositionsGroup1) return form19(record);
      if (isPositionsGroup2) return form20(record);
      if (isPositionsGroup3) return form21(record);
      return form22(record);
    }
  }
  return null;
};
